import { css, ITypography } from '@conexasaude/hero'
import { SerializedStyles } from '@emotion/utils'

export const typoMixin = (
  { typography }: { typography: ITypography },
  typo: string,
): SerializedStyles => {
  return css`
    font-family: ${typography[typo].fontFamily};
    font-size: ${typography[typo].fontSize};
    font-weight: ${typography[typo].fontWeight};
    line-height: ${typography[typo].lineHeight};
    letter-spacing: ${typography[typo].letterSpacing};
  `
}

export default typoMixin
